import { render } from "./Centerpreview.vue?vue&type=template&id=7953406d"
import script from "./Centerpreview.vue?vue&type=script&lang=js"
export * from "./Centerpreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__